(function () {
  function normalizeText(value) {
    return (value || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9-]+/g, " ")
      .trim();
  }

  function normalizeMetal(value) {
    const v = normalizeText(value);

    if (v === "argent" || v === "argente" || v === "gris") return "metal-gris";
    if (v === "or" || v === "dore" || v === "jaune") return "metal-jaune";

    return "";
  }

  function normalizeColor(value) {
    const v = normalizeText(value);

    const colors = ["blanc", "noir", "violet", "marron", "rose", "argente", "dore"];

    if (colors.includes(v)) return v;

    return "";
  }

  function getSelectedTokens() {
    const tokens = [];

    document.querySelectorAll(".product-form__input, fieldset").forEach((group) => {
      const legend = normalizeText(group.querySelector("legend")?.textContent || "");
      const checked = group.querySelector("input[type='radio']:checked");

      if (!checked) return;

      const value = checked.value || "";

      if (legend.includes("couleur") || legend.includes("color")) {
        const color = normalizeColor(value);
        if (color) tokens.push(color);
      }

      if (legend.includes("metal") || legend.includes("métal") || legend.includes("metaux")) {
        const metal = normalizeMetal(value);
        if (metal) tokens.push(metal);
      }
    });

    document.querySelectorAll("select").forEach((select) => {
      const name = normalizeText(select.name + " " + select.id);
      const value = select.options[select.selectedIndex]?.textContent || select.value || "";

      if (name.includes("couleur") || name.includes("color")) {
        const color = normalizeColor(value);
        if (color) tokens.push(color);
      }

      if (name.includes("metal") || name.includes("métal") || name.includes("metaux")) {
        const metal = normalizeMetal(value);
        if (metal) tokens.push(metal);
      }
    });

    return [...new Set(tokens)].filter(Boolean);
  }

  function getFilterableImages() {
    return Array.from(document.querySelectorAll("img")).filter((img) => {
      const alt = normalizeText(img.alt || "");

      return (
        alt.includes("blanc") ||
        alt.includes("noir") ||
        alt.includes("violet") ||
        alt.includes("marron") ||
        alt.includes("rose") ||
        alt.includes("argente") ||
        alt.includes("dore") ||
        alt.includes("metal-gris") ||
        alt.includes("metal-jaune")
      );
    });
  }

  function imageMatches(img, tokens) {
    const words = normalizeText(img.alt || "").split(/\s+/).filter(Boolean);

    return tokens.every((token) => {
      return words.includes(normalizeText(token));
    });
  }

  function getWrapper(img) {
    return (
      img.closest(".product__media-item") ||
      img.closest(".thumbnail-list__item") ||
      img.closest("[id^='Slide-']") ||
      img.closest("li") ||
      img.closest(".media") ||
      img.parentElement ||
      img
    );
  }

  function showElement(element) {
    if (!element) return;
    element.removeAttribute("hidden");
    element.style.removeProperty("display");
  }

  function hideElement(element) {
    if (!element) return;
    element.setAttribute("hidden", "hidden");
    element.style.setProperty("display", "none", "important");
  }

  function filterImages() {
    const tokens = getSelectedTokens();
    const images = getFilterableImages();

    console.log("[Mementery filter] Tokens détectés :", tokens);
    console.log("[Mementery filter] Images filtrables :", images.length);

    if (!tokens.length || !images.length) return;

    const matchedImages = images.filter((img) => imageMatches(img, tokens));

    console.log("[Mementery filter] Images correspondantes :", matchedImages.length);

    if (!matchedImages.length) {
      console.warn("[Mementery filter] Aucun match pour :", tokens);
      return;
    }

    images.forEach((img) => {
      const wrapper = getWrapper(img);

      if (imageMatches(img, tokens)) {
        showElement(wrapper);
      } else {
        hideElement(wrapper);
      }
    });
  }

  function delayedFilter() {
    setTimeout(filterImages, 50);
    setTimeout(filterImages, 200);
    setTimeout(filterImages, 500);
    setTimeout(filterImages, 1000);
  }

  document.addEventListener("DOMContentLoaded", delayedFilter);

  document.addEventListener("change", function (event) {
    if (
      event.target.closest(".product-form__input") ||
      event.target.closest("variant-selects") ||
      event.target.closest("variant-radios")
    ) {
      delayedFilter();
    }
  });

  document.addEventListener("click", function (event) {
    if (
      event.target.closest(".product-form__input") ||
      event.target.closest("variant-selects") ||
      event.target.closest("variant-radios")
    ) {
      delayedFilter();
    }
  });

  if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
    if (PUB_SUB_EVENTS.optionValueSelectionChange) {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, delayedFilter);
    }

    if (PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, delayedFilter);
    }
  }
})();